numeral.register('locale', 'ar', {
    delimiters: {
        thousands: ',',
        decimal: '.',
    },
    abbreviations: {
        thousand: 'k',
        million: '.م',
        billion: 'b',
        trillion: '.ت',
    },
    ordinal: number => (number === 1 ? 'er' : 'e'),
    currency: {
        symbol: 'ر.س',
    },
});
